import { useLazyQuery } from '@apollo/client';
import { List } from '@elipssolution/harfang';
import { useTheme } from '@mui/material';
import { useCallback } from 'react';

import { ContactRow, CONTACTS_ITEM_HEIGHT } from './MobileWidgetContact';
import { FETCH_CONTACTS, FetchContactsType } from '../../api/contact';
import useCustomRouter from '../../hooks/useCustomRouter';
import { ContactType } from '../../types/contact';

const ExpandedWidgetContact = () => {
	const { push, query } = useCustomRouter();
	const { palette, shape } = useTheme();

	const { name, type } = query || {};

	const [fetchContacts, { data: contactsData }] = useLazyQuery<FetchContactsType>(FETCH_CONTACTS);

	const { contacts } = contactsData || {};
	const { count: contactsCount = 0 } = contacts || {};

	const listStyle = {
		height:
			contactsCount === 0
				? '100%'
				: // Height of every row + their bottom Divider, and the last row doesn't have a bottom Divider
				  `calc((${CONTACTS_ITEM_HEIGHT}px * ${contactsCount}) + ${contactsCount}px - 1px)`,
		borderRadius: shape.borderRadius * 2,
		border: `1px solid ${palette.divider}`,
		overflow: 'hidden',
	};

	const dataSource = useCallback(
		async (
			limit: number,
			offset: number,
		): Promise<{
			count: number;
			items: ContactType[];
		}> => {
			const { data, error } = await fetchContacts({
				variables: {
					page: {
						limit,
						offset,
					},
				},
			});

			if (error) {
				throw error;
			}

			const {
				contacts: { items = [], count = 0 },
			} = data ?? { contacts: {} };

			return { items, count };
		},
		[fetchContacts],
	);

	const handleContactClick = useCallback(
		({ id }: { id: ContactType['id'] }) => {
			push({
				pathname: 'widget/contact',
				query: { ...query, name, type, fromExpandedWidget: 'true', contactId: id },
			}).catch((error) => {
				throw error;
			});
		},
		[name, push, query, type],
	);

	return (
		<List<ContactType>
			style={listStyle}
			dataSource={dataSource}
			rowRenderer={ContactRow}
			onRowClick={handleContactClick}
		/>
	);
};

export default ExpandedWidgetContact;
